import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { PiDotsThree } from 'react-icons/pi';
import { FaSave } from 'react-icons/fa';
import Loader from '../components/Loader';
import { BiImport, BiRefresh } from 'react-icons/bi';
import Pagination from '../components/Pagination';
import Spinner from '../components/Spinner';


const Accounts = () => {
  const [accountData, setAccountData] = useState({
    username: '',
    first_name: '',
    last_name: '',
    courier_id: '',
    user_code: ''
  });

  const [metaData, setMetaData] = useState({
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
    itemsPerPage: 25,
  });

  const [accounts, setAccounts] = useState([]);
  const [imports, setImports] = useState([]);
  const [messages, setMessages] = useState('');
  const [newAccounts, setNewAccounts] = useState([]);
  const [deliveryService, setDeliveryService] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [shipments, setShipment] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentAccountId, setCurrentAccountd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  const fetchAccounts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}/api/accounts?page=${currentPage}`);
      if (!response.ok) {
        throw new Error('Failed to fetch accounts');
      }
      const data = await response.json();
      setAccounts(data['accounts']);
      setMetaData({
        totalItems: data.meta.totalItems,
        totalPages: data.meta.totalPages,
        currentPage: data.meta.currentPage,
        itemsPerPage: data.meta.itemsPerPage
      });
      console.log(data)
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchAccountsToImport = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/getCustomers`);
      if (!response.ok) {
        throw new Error('Failed to fetch accounts');
      }
      const data = await response.json();
      setImports(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = async () => {
    setLoading(true);
    setError(null);
    await fetchAccountsToImport();
    try {
      const response = await fetch(`${apiUrl}/api/import-accounts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(imports),
      })
      if (!response.ok) {
        throw new Error('Failed to fetch accounts');
      }
      const data = await response.json();
      setMessages(data['message'])
      fetchAccounts();
      setModalOpen(true)
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAccountData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      if (editMode) {
        await fetch(`${apiUrl}/api/accounts/${currentAccountId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(accountData),
        });
      } else if (accountData.shipper == 'Unknown') {
        await fetch(`${apiUrl}/api/accounts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            package: `UNK${accountData.id}`,
            tracking_number: accountData.tracking_number,
            account_id: 0,
            courier_id: accountData.courier_id,
            approved: false
          }),
        });
      }

      else {
        await fetch(`${apiUrl}/api/accounts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(accountData),
        });
      }
      fetchAccounts();
      handleModalClose();
      console.log(`Data sent ${accountData.tracking_number}`)
    } catch (error) {
      handleModalClose();
      console.error('Error saving package:', error);
      setError('Error saving package. Please try again.');
    } finally {
      setLoading(true);

    }
  };

  const handleEdit = (id) => {
    const packageToEdit = accounts.find((acc) => acc.id === id);
    if (packageToEdit) {
      setAccountData(packageToEdit);
      setCurrentAccountd(id);
      setEditMode(true);
    }
  };

  const handleDisableModal = (id) => {
    const packageToDelete = accounts.find((acc) => acc.id === id);
    if (packageToDelete) {
      setAccountData(packageToDelete);
      setCurrentAccountd(id);
      setModalDeleteOpen(true);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${apiUrl}/api/accounts/${id}`, {
        method: 'DELETE',
      });
      fetchAccounts();
      setModalDeleteOpen(false);
    } catch (error) {
      console.error('Error deleting package:', error);
      setError('Error deleting package. Please try again.');
      setModalDeleteOpen(false);

    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setEditMode(false);
    setCurrentAccountd(null);
    setAccountData({
      username: '',
      first_name: '',
      last_name: '',
      courier_id: '',
      user_code: ''
    });
    setNewAccounts([]);
  };





  useEffect(() => {
    fetchAccounts();
  }, [currentPage]);

  const handleInputNewAccountChange = (index, event) => {
    const importAccounts = [...newAccounts];
    importAccounts[index][event.target.name] = event.target.value;
    setNewAccounts(importAccounts);
  };

  const addAccountField = () => {
    setNewAccounts([...newAccounts, { username: '', first_name: '', last_name: '', courier_id: '', user_code: '' }]);
  };

  const removeAccountField = (index) => {
    const importAccounts = newAccounts.filter((_, i) => i !== index);
    setNewAccounts(importAccounts);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log(newAccounts)
      // Assuming `accounts` is an array of account objects to be created
      const responses = await Promise.all(
        newAccounts.map(account =>
          fetch(`${apiUrl}/api/accounts`, {  // Adjust the endpoint as needed
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(account)
          })
        )
      );

      // Check if all requests were successful
      const results = await Promise.all(responses.map(response => response.json()));

      // Optionally handle success (e.g., show confirmation or reset the form)
      console.log('All accounts have been posted:', results);
      alert('All accounts have been successfully created.');

      // Clear the accounts array or reset form data if needed
    } catch (error) {
      console.error('Error posting accounts:', error);
      alert('There was an error creating the accounts. Please try again.');
    } finally {
      setLoading(false);
      handleModalClose();
      fetchAccounts();
    }
  };




  return (
    <Layout>
      {loading ? <Spinner /> : <><main className="p-4 bg-base-100 shadow-xl w-4/5 lg:w-full h-[100%]">
        <section className="flex justify-between items-center mb-4">
          <h2 className="text-3xl font-semibold">Accounts</h2>
          {/* <button className="btn btn-primary text-white" onClick={() => handleRefresh()}>
            <BiRefresh /> Import Accounts
          </button> */}
        </section>

        {error && <div className="alert alert-error">{error}</div>}

        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                <label>
                  <input type="checkbox" className="checkbox" />
                </label>
              </th>
              <th className="border px-2 sm:px-4 py-2 text-left font-semibold">MailBox Number</th>
              <th className="border px-2 sm:px-4 py-2 text-left font-semibold">First Name</th>
              <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Last Name</th>
              <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Pickup Location</th>
              {/* <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {accounts.map((acc) => (
              <tr key={acc.id} className="hover:bg-slate-200">
                <td className='border border-gray-300'>
                  <label>
                    <input type="checkbox" className="checkbox" />
                  </label>
                </td>
                <td className="border border-gray-300">{acc.mailboxNumber}</td>
                <td className="border border-gray-300">{acc.first_name}</td>
                <td className="border border-gray-300">{acc.last_name}</td>
                <td className="border border-gray-300">{acc.pickupLocation}</td>


                {/* <td className="border border-gray-300">
                  <div className="dropdown">
              <div tabIndex={0} role="button" className="btn m-1 bg-base-300"><PiDotsThree/></div>
              <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                <li onClick={() => handleEdit(acc.id)}><a>Edit</a></li>
                <li onClick={() =>  handleDisableModal(acc.id)} className='text-red-500'><a>Delete</a></li>
              </ul>
            </div>
                  </td> */}
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={metaData.currentPage}
          totalPages={metaData.totalPages}
          totalItems={metaData.totalItems}
          itemsPerPage={metaData.itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </main>


        {modalOpen && (
          <dialog className="modal modal-open bg-gray-50">
            <div class="modal-box">
              <div className='flex gap-4'>
                <BiImport />
                <h3 class="text-lg font-bold "> Imports {accountData.username}</h3>
              </div>
              <p class="py-4">{messages}</p>

              <div className='flex justify-center items-center'>

                <button className='btn' onClick={() =>
                  setModalOpen(false)
                }>Close</button>
              </div>
            </div>

          </dialog>
        )}




      </>}

    </Layout>
  );
};

export default Accounts;
